import { render } from "./CookiePreferencesModal.vue?vue&type=template&id=ca827144&scoped=true"
import script from "./CookiePreferencesModal.vue?vue&type=script&lang=js"
export * from "./CookiePreferencesModal.vue?vue&type=script&lang=js"

import "./CookiePreferencesModal.vue?vue&type=style&index=0&id=ca827144&scoped=true&lang=scss"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca827144"]])

export default __exports__